import { useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import { API_ASSET_MAPING_CONFIG_POST } from '../../constants';
import solutionsStore, {
  useCurrentSolutionName,
  useSolutionDetails,
} from '../../redux';
import { SolutionMappingConfigItem } from '../../types';
import SolutionMappingEditModal from './SolutionMappingEditModal';

type Props = {
  item: SolutionMappingConfigItem;
  sitesId?: string;
  id?: string;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionMappingCreateContainer({
  item,
  sitesId,
  id,
  open,
  onClose,
}: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const solutionName = useCurrentSolutionName();
  const actions = useStoreUnitActions(solutionsStore);
  const [solutionDetails] = useSolutionDetails();
  const isISA95Standard =
    solutionDetails?.isIsa95Standard || false;

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generateApiPath(API_ASSET_MAPING_CONFIG_POST, {
          solutionId,
          siteId: !isISA95Standard ? '00' : sitesId,
          twinId: id,
        }),
        params,
      }),
    (params) => {
      showAlert({
        type: AlertType.Success,
        title: 'Digital Twin Configuration created',
        text: `Digital Twin Configuration is created successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.assetMappingConfig({
        solutionId,
        siteId: !isISA95Standard ? '00' : sitesId,
        twinId: id,
      });
    }
  );

  return (
    <SolutionMappingEditModal
      title="Create Digital Twin Configuration"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
}

export default SolutionMappingCreateContainer;
